import React, { useEffect, useState } from "react";
import BannerSection from "./BannerSection";
import "./css/Academisp.css";

const AcademicProcedure = () => {
  const [documentList, setDocumentList] = useState([]);
  const [ageCriteriaText, setAgeCriteriaText] = useState("");
  const [registrationText, setRegistrationText] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [outdoor,setOutdoor]= useState("");
  const [handbook,setHandbook]=useState("")

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch academic documents
        const docResponse = await fetch(
          `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_PROJECT_PATH}/items/academicdoc?fields=*.*.*`,
          // "https://cms.maitretech.com/thekatarahillsschool/items/academicdoc?fields=*.*.*"
        );
        const docResult = await docResponse.json();
        const docs = docResult?.data
          ?.flatMap((item) => item.doclists)
          .filter(Boolean);
        setDocumentList(docs || []);

        // Fetch age and registration info
        const academicResponse = await fetch(
          `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_PROJECT_PATH}/items/academic?fields=*.*.*`,
 
        );
        const academicResult = await academicResponse.json();
        const academicData = academicResult?.data?.[0];

        setAgeCriteriaText(academicData?.agecreteriadetails || "");
        setRegistrationText(academicData?.registrationprocess || "");
        setOutdoor(academicData?.outdoor_time ||"");
        setHandbook(academicData?.handbook || "");
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to load academic information.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const sections = [
    {
      title: "Academic Procedure",
      content: [
        {
          subtitle: "Age Requirement",
          text: ageCriteriaText
        },
        {
          subtitle: "Registration",
          text: registrationText
        },
        {
          subtitle: "Submission of Documents",
          text: "Following Registration, duly filled Application form needs to be submitted along with the documents listed below within 5 days of the registration date.",
          list: documentList
        },
        {
          subtitle: "Outdoor Time",
          text: outdoor
        },
        {
          subtitle: "Junior Champions Preschool Handbook",
          text: handbook,
          contact: "thekatarahillsschool@gmail.com"
        }
      ]
    }
  ];

  return (
    <>
      <BannerSection />
      <div className="container-fluid p-0">
        <div className="container-fluid d-flex latest_card_box_add p-0">
          <div className="admssionleft text-left">
            {loading && <p>Loading academic procedure...</p>}
            {error && <p className="text-danger">{error}</p>}

            {!loading &&
              !error &&
              sections.map((section, idx) => (
                <div key={idx}>
                  <div className="title">
                    <h3
                      className="text-center mb-4"
                      style={{ color: "black", fontWeight: "bold" }}
                    >
                      {section.title}
                    </h3>

                    {section.content.map((item, i) => (
                      <div key={i} className="procedure-section mb-4">
                        <h5>
                          <b>{item.subtitle}:</b>
                        </h5>
                        <p>{item.text}</p>

                        {item.list && item.list.length > 0 && (
                          <ul className="document${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_PROJECT_PATH}/items/principal?fields=*.*.*`,-list">
                            {item.list.map((doc, j) => (
                              <li key={j}>
                                {typeof doc === "string"
                                  ? doc
                                  : doc?.title || "Untitled Document"}
                              </li>
                            ))}
                          </ul>
                        )}

                        {item.contact && (
                          <h5>
                            Email to:{" "}
                            <a href={`mailto:${item.contact}`}>{item.contact}</a>
                          </h5>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AcademicProcedure;
